const twoDigitsAfterPoint = /^\d+(?:\.[0-9]{1,2})?$/;

export {twoDigitsAfterPoint};
